import notify from '@/helpers/airbrake';

window.addEventListener('error', ({ error, ...params }) => notify({ error, params }));
window.addEventListener('unhandledrejection', ({ reason }) => notify(reason));
window.addEventListener('rejectionhandled', ({ reason }) => notify(reason));

